import type { FC } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { ConditionalWrapper } from "../../ConditionalWrapper";
import { Link } from "../../Link";
import { ItemText } from "../../NavigationBar/SidebarItemElements";
import { ProfileAvatar } from "./ProfileAvatar";
import "@nectary/components/tooltip";

const AvatarContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px 0 8px 16px;
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledItemText = styled(ItemText)`
  margin: 0;
  line-height: 22px;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledLink = styled(Link)`
  color: #2399f0;
  font-weight: 500;
`;

type ExtendedProfileAvatarProps = {
  name: string;
  onClick: () => void;
};
export const ExtendedProfileAvatar: FC<ExtendedProfileAvatarProps> = ({
  name,
  onClick,
}) => {
  const intl = useIntl();
  return (
    <AvatarContainer>
      <ProfileAvatar name={name} />
      <NameContainer>
        <ConditionalWrapper
          shouldWrap={name.length > 16}
          wrapper={(children) => (
            <sinch-tooltip text={name} orientation={"right"}>
              {children}
            </sinch-tooltip>
          )}
        >
          <StyledItemText noWrap>{name}</StyledItemText>
        </ConditionalWrapper>
        <StyledLink to="/profile" onClick={onClick}>
          {intl.formatMessage({ id: "menuItemProfile" })}
        </StyledLink>
      </NameContainer>
    </AvatarContainer>
  );
};
